import { render, staticRenderFns } from "./BusinessPartnerResponsibleList.vue?vue&type=template&id=500ea2cf&"
import script from "./BusinessPartnerResponsibleList.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerResponsibleList.vue?vue&type=style&index=0&id=500ea2cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports